<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sz4PFd/tc-custom/9781497609273.jpg?1728259219662" alt="This image is the cover for the book Death of Nnanji, The Seventh Sword"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death of Nnanji, The Seventh Sword
      </h1>
      <p class="bookDescription body article font2">
        <b>In this masterful sword-and-sorcery epic, “Duncan has created strong and moving characters . . . and a world as rich and layered as our own” (Iceberg Ink).</b><br/>  <br/> For fifteen years, the truce has held. Swordsmen of the Tryst of Casr have kept the peace and extended the rule of law over half the world, but now sorcerers have started killing swordsmen again, and swordsmen traitors are aiding them. Shonsu—who was Wallie Smith before he became a swordsman of the seventh rank and liege lord of the Tryst—must once more gird on the seventh sword of Chioxin, and this time he rides out to fight the war that he hoped would never come. As he leads his army forth, its two most junior members are Vixini, son of Shonsu, and Addis, son of Nnanji, who has an oath of vengeance to fulfill. Their failure or success will determine the fate of the world for the next thousand years.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Duncan
      </h2>
      
      <p class="authorDescription body article">Dave Duncan (1933&ndash;2018) was born in Scotland, and received his diploma from Dundee High School and got his college education at the University of Saint Andrews. He moved to Canada in 1955, where he lived with his wife. Duncan spent thirty years as a petroleum geologist. He has had dozens of fantasy and science fiction novels published, among them <I>A Rose-Red City</I>, <I>Magic Casement</I>, and <I>The Reaver Road</I>, as well as a highly praised historical novel, <I>Daughter of Troy</I>, published, for commercial reasons, under the pseudonym Sarah B. Franklin. He also published the Longdirk series of novels, <I>Demon Sword</I>, <I>Demon Knight</I>, and <I>Demon Rider</I>, under the name Ken Hood.<BR /> &#160;<BR /> In the fall of 2007, Duncan&rsquo;s 2006 novel, <I>Children of Chaos</I>, published by Tor Books, was nominated for both the Prix Aurora Award and the Endeavour Award. In May 2013, Duncan, a 1989 founding member of SFCanada, was honored by election as a lifetime member by his fellow writers, editors, and academics. He passed away in 2018. Visit <a href="https://www.daveduncanauthor.com/">https://www.daveduncanauthor.com/ </a>for more information on the author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9ba807e